import { ICommand, RelayCommand } from "Application";
import { FieldType, KeyValuePair } from "@shoothill/core";
import moment from "moment";

import { MentorAbsenceViewModel } from "../MentorAbsenceViewModel";
import { MentorAbsenceModel } from "../MentorAbsenceModel";
import { WeeklyRotaDetailsViewModel } from "../../WeeklyRotaDetailViewModel";

export class CommandsManager {
    constructor(private viewModel: MentorAbsenceViewModel) {}

    // ─── Field update commands ────────────────────────────────────────────────

    public updateMentorStartDateCommand: ICommand = new RelayCommand((value: Date) => {
        this.updateField("absenceStartDate", moment(value).format("YYYY-MM-DD"));
    });

    public updateMentorEndDateCommand: ICommand = new RelayCommand((value: Date) => {
        this.updateField("absenceEndDate", moment(value).format("YYYY-MM-DD"));
    });

    public updateMentorShiftCommand: ICommand = new RelayCommand((kvp: KeyValuePair) => {
        this.updateField("absenceShiftAM", kvp.key === "1" ? "00:00:00" : "12:00:00");
        this.updateField("absenceShift", kvp.key);
    });

    public updateMentorTimeCommand: ICommand = new RelayCommand((kvp: KeyValuePair) => {
        const isShift1 = this.viewModel.getValue("absenceShift") === "1";
        this.updateField("absenceShiftPM", isShift1 && kvp.key === "1" ? "11:59:00" : "23:59:00");
        this.updateField("absenceTime", kvp.key);
    });

    public updateMentorSelectCommand: ICommand = new RelayCommand((kvp: KeyValuePair) => {
        this.updateField("mentorId", kvp.key);
    });

    // ─── Form action commands ─────────────────────────────────────────────────

    /** Returns a save command that submits the absence and signals the view to close. */
    public addMentorAbsenceCommand(parentViewModel: WeeklyRotaDetailsViewModel): ICommand {
        return new RelayCommand(async () => {
            await this.viewModel.managers.api.addMentorAbsence(parentViewModel);
        });
    }

    // ─── Private helpers ──────────────────────────────────────────────────────

    private updateField(fieldName: keyof FieldType<MentorAbsenceModel>, value: any): void {
        this.viewModel.setValue(fieldName, value);
        this.viewModel.isFieldValid(fieldName);
    }
}
